import * as S from "./styles";
import { SkeletonLoading } from "@/main/components/shared/styles";
import { isNullUndefined } from "@/main/services/utils";
interface ITypographyLabelTextProps {
	label: string | undefined;
	text: string | undefined;
	isLoading?: boolean;
}

function TypographyLabelText({ label, text, isLoading = false }: ITypographyLabelTextProps) {
	if (isLoading)
		return (
			<S.Container>
				<S.Label>
					<SkeletonLoading />
				</S.Label>
				<S.Text>
					: <SkeletonLoading />
				</S.Text>
			</S.Container>
		);
	if (text === "") return null;

	return (
		<S.Container>
			<S.Label>{label}</S.Label>
			<S.Text>: {isNullUndefined(text) ? "-" : text}</S.Text>
		</S.Container>
	);
}

export default TypographyLabelText;
